'use client';

import type { ReactNode } from 'react';
import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { BodyDefault, MetaDefault } from '@terra/ui-design-system';

export function ListPageNameCell({
  icon,
  title,
  subtitle,
  badges,
}: {
  icon: ReactNode;
  title: string;
  subtitle?: string | null;
  badges?: ReactNode;
}) {
  return (
    <HStack gap={2} h="full" alignItems="center" minW={0} w="full">
      <Box flexShrink={0} display="inline-flex">
        {icon}
      </Box>
      <VStack gap={0} alignItems="stretch" minW={0} flex={1}>
        <HStack gap={1.5} minW={0}>
          <BodyDefault truncate minW={0} title={title}>
            {title}
          </BodyDefault>
          {badges}
        </HStack>
        {subtitle ? (
          <MetaDefault color="fg.subtle" truncate title={subtitle}>
            {subtitle}
          </MetaDefault>
        ) : null}
      </VStack>
    </HStack>
  );
}
